import type { GlobalOptions } from './args.js';

export interface CommandResult {
  data: unknown;
  human?: string;
  warnings?: string[];
  exitCode?: number;
  streamed?: boolean;
}

export function printResult(result: CommandResult, options: GlobalOptions): void {
  if (options.json || !result.human) {
    const space = options.pretty === false ? 0 : 2;
    process.stdout.write(`${JSON.stringify(result.data ?? null, null, space)}\n`);
  } else {
    process.stdout.write(`${result.human}\n`);
  }
  for (const warning of result.warnings ?? []) process.stderr.write(`Warning: ${warning}\n`);
}

export function success(message: string, data: Record<string, unknown> = {}): CommandResult {
  return { data: { success: true, message, ...data }, human: message };
}
